import type {CreateExtArgs} from '@wix/document-manager-core'

export const mediaOverlayControlsMetadata = {
    canConnectToCode: () => false,
    shouldAutoSetNickname: false,
    isRepeatable: ({coreConfig}: CreateExtArgs) => coreConfig.experimentInstance.isOpen('dm_mediaPlayerInRepeater')
}
